export const messages = {
    "wre-dashboard.nav-menu.item.shared": "共有",
    "wre-dashboard.nav-menu.item.backups": "バックアップ",
    "wre-dashboard.nav-menu.item.machines": "マシン",
    "wre-dashboard.nav-menu.item.account": "アカウント",
    "wre-dashboard.search.input.hint": "検索",
    "wre-dashboard.search.label.breadcrumb": "検索結果",
    "wre-dashboard.search.message.empty": "検索に一致する項目はありません",
    "wre-dashboard.side-bar.selected.title:plural": "{count}アイテム選択済み | {count}アイテム選択済み",
    "wre-dashboard.side-bar.backup-type.disk": "ディスク",
    "wre-dashboard.side-bar.backup-type.file": "ファイル",
    "wre-dashboard.side-bar.backup-type.notarized": "公証済みのファイルとフォルダ",
    "wre-dashboard.side-bar.backup-type.exchange": "アプリケーション - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "アプリケーション - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "アプリケーション - システム状態",
    "wre-dashboard.side-bar.backup-type.application": "アプリケーション",
    "wre-dashboard.space-indicator.label.left": "残り{spaceFree}",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} 使用",
    "wre-dashboard.space-indicator.label.unlimited": "無制限",
    "wre-dashboard.backups-table.column.name": "名前",
    "wre-dashboard.backups-table.column.size": "サイズ",
    "wre-dashboard.backups-table.column.version": "前回のバックアップ",
    "wre-dashboard.backups-table.message.no-backups": "クラウドにはまだバックアップがありません",
    "wre-dashboard.backups-sidebar.label.size": "サイズ",
    "wre-dashboard.backups-sidebar.label.type": "タイプ",
    "wre-dashboard.backups-sidebar.label.version": "最新バージョン",
    "wre-dashboard.backups-sidebar.label.created": "作成",
    "wre-dashboard.backups-sidebar.label.machine": "マシン",
    "wre-dashboard.backups-sidebar.label.owner": "所有者",
    "wre-dashboard.content-table.column.name": "名前",
    "wre-dashboard.content-table.column.versions": "バージョン",
    "wre-dashboard.content-table.column.volumes": "ボリューム",
    "wre-dashboard.content-table.column.path": "パス",
    "wre-dashboard.content-table.column.size": "サイズ",
    "wre-dashboard.content-table.column.version": "最新バージョン",
    "wre-dashboard.content-table.action.versions": "バージョン",
    "wre-dashboard.content-table.action.restore": "ダウンロード",
    "wre-dashboard.content-table.action.share": "リンクの共有",
    "wre-dashboard.content-table.label.size": "サイズ",
    "wre-dashboard.content-table.label.created": "作成",
    "wre-dashboard.content-table.label.modified": "変更日",
    "wre-dashboard.content-table.message.empty-folder": "このフォルダは空です",
    "wre-dashboard.password-dialog-box.title.backup": "暗号化されたバックアップ",
    "wre-dashboard.password-dialog-box.title.archive": "暗号化されたアーカイブ",
    "wre-dashboard.password-dialog-box.message.backup": "バックアップ{displayName}にアクセスするためのパスワードを指定してください",
    "wre-dashboard.password-dialog-box.message.archive": "アーカイブ{displayName}にアクセスするためのパスワードを指定してください",
    "wre-dashboard.password-dialog-box.hint.password": "パスワード",
    "wre-dashboard.password-dialog-box.message.invalid-password": "パスワードが正しくありません",
    "wre-dashboard.form.button.open": "開く",
    "wre-dashboard.form.button.close": "閉じる",
    "wre-dashboard.form.button.cancel": "キャンセル",
    "wre-dashboard.form.button.delete": "削除",
    "wre-dashboard.shared-content-table.column.name": "名前",
    "wre-dashboard.shared-content-table.column.location": "ロケーション",
    "wre-dashboard.shared-content-table.column.source": "ソース",
    "wre-dashboard.shared-content-table.column.days": "日",
    "wre-dashboard.shared-content-table.column.downloads": "ダウンロード",
    "wre-dashboard.shared-content-table.column.shared": "共有場所",
    "wre-dashboard.shared-content-table.label.shared": "共有場所",
    "wre-dashboard.shared-content-table.label.backup": "ソース",
    "wre-dashboard.shared-content-table.action.share": "リンクの共有",
    "wre-dashboard.shared-content-table.action.settings": "リンクの設定",
    "wre-dashboard.shared-content-table.action.delete": "リンクの削除",
    "wre-dashboard.shared-content-table.action.delete-selected": "リンクの削除",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree}/{totalSpace}の空き領域",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}:無制限の領域",
    "wre-dashboard.account-page.button.sign-out": "サインアウト",
    "wre-dashboard.account-page.button.manage-subscription": "ライセンスの管理",
    "wre-dashboard.account-page.message.subscription.active": "{brandName}の領域のライセンスの有効期限",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName}のトライアル版の有効期限",
    "wre-dashboard.account-page.message.subscription.expired": "{brandName}の領域のライセンスの有効期限",
    "wre-dashboard.account-page.message.worm-status.storage-full": "{brandName}のストレージに空き領域がありません。データをクラウドにバックアップまたはアーカイブできません。",
    "wre-dashboard.account-page.message.worm-status.less-than": "空き領域は{percent}パーセント未満です。{brandName}は間もなく使用できなくなります。",
    "wre-dashboard.versions-dialog-box.title": "{fileName}のバージョン",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "リンクのコピー",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "リンクの設定",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "このリンクを使用して誰でもデータの最新バージョンを表示できます",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "{creationDate}に共有",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "リンクをコピー済み",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "リンクのコピーエラー",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "リンクの削除",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "このリンクは、すべてのユーザーに対して無効になります",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "リンクの削除",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "これらのリンクは、すべてのユーザーに対して無効になります",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "リンクの設定",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "リンクの削除",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "完了",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "パスワード",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "パスワードをリセット",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "パスワードによる保護",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "パスワードを使用してこのリンクを保護",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "有効期限",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "ダウンロードの制限",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "{splitMarker}日でこのリンクを無効にする | {splitMarker}日でこのリンクを無効にする",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "{splitMarker}回のダウンロード後にこのリンクを無効にする | {splitMarker}回のダウンロード後にこのリンクを無効にする",
    "wre-dashboard.sub-accounts-dialog-box.title": "アカウント",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "検索",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "検索に一致する項目はありません",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "名前",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "使用状況",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "前回のバックアップ",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "有効期間",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} の空き {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "ボリュームサブスクリプション",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "有効期限切れ",
    "wre-dashboard.machines-table.column.name": "名前",
    "wre-dashboard.machines-table.column.size": "サイズ",
    "wre-dashboard.machines-table.message.no-machines": "クラウドにはまだマシンがありません"
};
